import { render, staticRenderFns } from "./MpCompareV2.vue?vue&type=template&id=100db9c6&scoped=true&"
import script from "./MpCompareV2.vue?vue&type=script&lang=js&"
export * from "./MpCompareV2.vue?vue&type=script&lang=js&"
import style0 from "./MpCompareV2.vue?vue&type=style&index=0&id=100db9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100db9c6",
  null
  
)

export default component.exports